import { Fragment } from 'react';

import { useHasCaptureAccess } from '~/hooks/account';
import { segmentTypes } from '~/lib/segments';

import AddCapturePlan from './AddPlan/AddCapturePlan';
import AddPlanSection from './AddPlan/AddPlanSection';
import destinationGroups from './destinationsConfigurations';
import PlanDestinationGroup from './PlanDestinationGroup';
import useAvailableDestinationsLegacy from './useAvailableDestinationsLegacy';

export default function LegacyPlanDestinations({
  userContainer,
  segment,
  account,
}) {
  const showAlerting = userContainer.shouldShowDestinationGroup('alerting');
  const showAdsProducts = userContainer.shouldShowDestinationGroup('ads');
  const showCapture = useHasCaptureAccess();
  const showPersonalization = userContainer.shouldShowDestinationGroup(
    'personalization',
  );

  const isCompany = segment.type === segmentTypes.company;

  const enabledDestinations = useAvailableDestinationsLegacy(
    segment.type,
    account,
    showAlerting,
    showAdsProducts,
    showPersonalization,
  );

  const marketingPanels = {
    capture: {
      show: isCompany && !showCapture,
      panel: (
        <div className="mb-4">
          <AddCapturePlan segment={segment} />
        </div>
      ),
    },

    alerting: {
      show: !showAlerting,
      panel: (
        <AddPlanSection
          segment={segment}
          title="Alerting"
          user={userContainer}
        />
      ),
    },
    advertising: {
      show: !showAdsProducts,
      panel: (
        <AddPlanSection
          segment={segment}
          title="Advertising"
          user={userContainer}
        />
      ),
    },
    personalization: {
      show: isCompany && !showPersonalization,
      panel: (
        <AddPlanSection
          segment={segment}
          title="Personalization"
          user={userContainer}
        />
      ),
    },
  };

  return (
    <>
      {destinationGroups.map((group) => (
        <Fragment key={group.key}>
          <PlanDestinationGroup
            audiences={!!group.audiences}
            description={group.description}
            enabled={enabledDestinations}
            items={group.items}
            key={group.title}
            segment={segment}
            title={group.title}
          />

          {marketingPanels[group.key]?.show
            ? marketingPanels[group.key].panel
            : null}
        </Fragment>
      ))}
    </>
  );
}
